import React from 'react'
import Accordion from '../../Shared/Accordion'
import {
  FilterSharpIcon,
  ArrowLeftIcon,
  ArrowRightIcon
} from '../../Shared/SvgIcons'
import HyperTooltip from '../../Shared/HyperTooltip';
import {
  SideBarContainer,
  ExpandHeader,
  ReduceHeader,
  FilterTitleWrapper,
  FilterContainer
} from './styles'
import { FilterCategory } from '../../Shared/FilterCategory';
import { FilterStatus } from '../../Shared/FilterStatus';
import { FilterPrice } from '../../Shared/FilterPrice';
import { FilterCurrency } from '../../Shared/FilterCurrency';

export const SideBar = (props) => {
  const {
    isOpenSideMenu,
    setIsOpenSideMenu,
    filterValues,
    handleChangeCurrency,
    handleChangeFilterItem,
    method,
    onChangeMethod,
    handleChangeFilterCategory,
    setFilterValues
  } = props

  return (
    <SideBarContainer>
      {isOpenSideMenu ? (
        <ExpandHeader>
          <span onClick={() => setIsOpenSideMenu(false)}>
            <ArrowLeftIcon />
          </span>
          <FilterTitleWrapper>
            <FilterSharpIcon />
            <span>Filters</span>
          </FilterTitleWrapper>
        </ExpandHeader>
      ) : (
        <ReduceHeader  onClick={() => setIsOpenSideMenu(true)}>
          <HyperTooltip text="Filters">
            <ArrowRightIcon />
          </HyperTooltip>
        </ReduceHeader>
      )}
      <FilterContainer active={isOpenSideMenu}>
        <Accordion title='Category' isOpened>
          <FilterCategory
            handleChangeFilterCategory={handleChangeFilterCategory}
            filterValues={filterValues}
            setFilterValues={setFilterValues}
          />
        </Accordion>
        <Accordion
          title='Status'
          isOpened={false}
        >
          <FilterStatus
            method={method}
            onChangeMethod={onChangeMethod}
          />
        </Accordion>
        <Accordion title='Price' isOpened>
          <FilterPrice
            filterValues={filterValues}
            handleChangeFilterItem={handleChangeFilterItem}
          />
        </Accordion>
        <Accordion title='Currency' isOpened>
          <FilterCurrency
            filterValues={filterValues}
            handleChangeCurrency={handleChangeCurrency}
          />
        </Accordion>
      </FilterContainer>
    </SideBarContainer>
  );
};